<template>
  <div class="credentials-input-field">
    <ValidationProvider :rules="validations" ref="input" slim>
      <div class="input-group">
        <input
          class="input-container"
          :class="{ empty: empty, error: validationError || error }"
          :value="fieldValue"
          :type="inputType"
          v-model="value"
          v-on:input="updateInput($event.target.value)"
          v-on:blur="setShowPassword(false)"
          autocapitalize="none"/>
        <label class="field-name">{{ fieldName }}</label>
        <label v-if="validationError || errorMessage" class="top-left-label">{{ validationError || errorMessage }}</label>
      </div>
      <div v-if="isPasswordField" class="image-wrapper">
        <img v-if="showPassword" src="../../assets/eye_blue.svg" v-on:click="onEyeClick(false)"/>
        <img v-else src="../../assets/eye.svg" v-on:click="onEyeClick(true)"/>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>

export default {
  name: 'CredentialsInputField',
  props: {
    error: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
    fieldValue: {
      type: String,
    },
    updateInput: {
      type: Function,
    },
    fieldName: {
      type: String,
    },
    fieldType: {
      type: String,
      validator: val => ['text', 'password'].includes(val),
    },
    validations: {
      type: String,
    },
    field: {
      type: Object,
    },
  },
  data() {
    return {
      showPassword: false,
      validationError: null,
      value: '',
    };
  },
  computed: {
    empty() {
      return !this.fieldValue || this.fieldValue === '';
    },
    isPasswordField() {
      return this.fieldType === 'password';
    },
    inputType() {
      return this.isPasswordField && !this.showPassword ? 'password' : 'text';
    },
  },
  methods: {
    setShowPassword(showPassword) {
      this.showPassword = showPassword;
    },
    focusOnInput() {
      this.$refs.input.focus();
    },
    onEyeClick(showPassword) {
      this.setShowPassword(showPassword);
      this.focusOnInput();
    },
    async validate() {
      this.validationError = null;
      const isValid = await this.$refs.input.validate();
      if (!isValid.valid) {
        [this.validationError] = isValid.errors;
        const textField = this.$el;
        if (textField) {
          textField.classList.add('animation');
          setTimeout(() => textField.classList.remove('animation'), 1000);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
    .credentials-input-field {
      position: relative;

      .input-group {
        height: 56px;
        position: relative;

        .top-left-label {
          position: absolute;
          top: -13px;
          right: -2px;
          width: 100%;
          text-align: left;
          font-size: 11px;
          color: $riseup_gray_2;
        }

        .input-container {
          color: $riseup_black;
          font-family: SimplerPro;
          font-size: 20px;
          width: 100%;
          height: 100%;
          padding: 10px 10px 10px 5px;
          display: block;
          border: 1px solid $riseup_gray_2;
          border-radius: 3px;

          &:focus {
            outline: none;
            border: 1px solid $riseup_light_blue;
          }

          &:focus ~ .field-name,
          &:valid ~ .field-name {
            position: relative;
            top: -75px;
            font-size: 12px;
            color: $riseup_light_blue;
            transition: 300ms ease all;
          }

          &.empty:not(:focus):not(:disabled) ~ .field-name {
            color: $riseup_gray_2;
            font-size: 20px;
            font-weight: normal;
            position: relative;
            pointer-events: none;
            right: 10px;
            top: -38px;
            transition: 300ms ease all;
          }

          &:not(.empty):not(:focus):not(:disabled):not(.error) {
            border: 1px solid $riseup_light_blue;
          }

          &:not(.empty).error {
            border: 1px solid $riseup_coral;
          }

          &:not(.empty).error ~ .field-name {
            color: $riseup_coral;
          }

        }
      }
      .image-wrapper {
        position: absolute;
        top: 17px;
        left: 20px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/CredentialsInputField.vue